<template>
    <hr  class="hr-custom"/>
</template>

<style scoped lang="scss">
.hr-custom {
    border: 1px solid #efeffd;
    margin:0;
}
</style>